import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
const CLAIMED_PERCENT = 68;
export function Scarcity() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23 * 3600 + 58 * 60 + 45);
  return <section aria-labelledby="scarcity-heading" className="border-y-2 border-gold bg-navy-800" data-id="element-161" data-mp="20lp63m6mmuz2">
      <div className="mx-auto flex max-w-page flex-col gap-7 px-4 py-10 sm:px-5 lg:flex-row lg:items-center lg:justify-between lg:gap-10 lg:py-12" data-id="element-162" data-mp="1wjak4t7nvf3k">
        <div data-id="element-163" data-mp="18uhqj3eihjc4">
          <h2 id="scarcity-heading" className="font-display text-xl font-extrabold tracking-[-0.03em] text-white sm:text-3xl" data-id="element-164" data-mp="18rvf2soi2jom">
            Limited-time offer
          </h2>
          <p className="mt-2 text-sm text-mist sm:mt-3" data-id="element-165" data-mp="1cvuu16u4tafv">
            Launch pricing ends today. Price returns to{' '}
            <span className="font-semibold text-white" data-id="element-166" data-mp="p5qq0yd178oc">$97</span> tomorrow.
          </p>
        </div>

        <div data-id="element-167" data-mp="l56vm2juej5w">
          <p className="text-[10px] uppercase tracking-[0.16em] text-steel sm:text-[11px]" data-id="element-168" data-mp="l3m0obtm8y7i">
            Launch pricing expires in
          </p>
          <p className="mt-2 font-display text-4xl font-extrabold tracking-[-0.03em] text-gold sm:text-5xl" data-id="element-169" data-mp="31fps82ewme2p">
            {hours}
            <span className="text-steel" data-id="element-170" data-mp="3b7vfwzy4i9c3">:</span>
            {minutes}
            <span className="text-steel" data-id="element-171" data-mp="3b9y6pm73o6hv">:</span>
            {seconds}
          </p>
        </div>

        <div className="lg:w-64" data-id="element-172" data-mp="3g8rohqtf6jnu">
          <div className="flex items-baseline justify-between gap-3" data-id="element-173" data-mp="2ijg4soi44b61">
            <span className="text-[10px] uppercase tracking-[0.14em] text-steel sm:text-[11px]" data-id="element-174" data-mp="2ilasubookjec">
              Limited availability
            </span>
            <span className="font-display text-sm font-extrabold text-gold" data-id="element-175" data-mp="2sg2t5n9ndkct">
              {CLAIMED_PERCENT}% claimed
            </span>
          </div>
          <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-navy-600" role="progressbar" aria-valuenow={CLAIMED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Launch pricing spots claimed" data-id="element-176" data-mp="7qvhyrxxrf22">
            <div className="h-full rounded-full bg-gold" style={{
            width: `${CLAIMED_PERCENT}%`
          }} data-id="element-177" data-mp="23u08m5d81rb1" />
          </div>
        </div>
      </div>
    </section>;
}